// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  :root {
    --bg-base: rgba(255, 255, 255, 1);
    --bg-base-hover: rgba(248, 250, 251, 1);
    --bg-disabled: rgba(246, 248, 250, 1);
    --bg-field-hover: rgba(243, 244, 246, 1);
    --bg-highlight: rgba(235, 241, 255, 0.7);
    --bg-overlay: rgba(3, 7, 18, 0.4);
    --border-base: rgba(239, 240, 246, 1);
    --border-subtle: rgba(243, 244, 246, 1);
    --border-strong: rgba(226, 228, 233, 1);
    --border-hover: rgba(215, 218, 225, 1);
    --fg-base: rgba(10, 13, 20, 1);
    --fg-subtle: rgba(82, 88, 102, 1);
    --fg-muted: rgba(134, 140, 152, 1);
    --fg-faint: rgba(205, 208, 213, 1);
    --fg-smooth: rgba(32, 35, 45, 1);
  }

  html {
  overflow: hidden;
}

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.txt-base-regular {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  line-height: 1.5;
}
.txt-small-regular {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
.txt-base-regular-plus {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  line-height: 1.5;
}
.txt-small-regular-plus {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  line-height: 1.5;
}
.txt-small-regular-semibold {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  line-height: 1.5;
}
.txt-compact-small {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  line-height: 1.625;
}
.txt-compact-small-plus {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  line-height: 1.625;
}
.txt-medium-regular {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  line-height: 1.5;
}
.txt-compact-medium {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  line-height: 1.25;
}
.txt-compact-medium-plus {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  line-height: 1.25;
}
.txt-large-semibold {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 500;
  line-height: 1.5;
}
.txt-large-bold {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  line-height: 1.5;
}
.txt-xlarge-semibold {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.5;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-2 {
  inset: 0.5rem;
}
.inset-3 {
  inset: 0.75rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0 {
  bottom: -0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-8 {
  bottom: -2rem;
}
.-right-1 {
  right: -0.25rem;
}
.-top-11 {
  top: -2.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-5 {
  left: 1.25rem;
}
.left-\\[calc\\(50\\%-4rem\\)\\] {
  left: calc(50% - 4rem);
}
.right-0 {
  right: 0px;
}
.right-0\\.5 {
  right: 0.125rem;
}
.right-2 {
  right: 0.5rem;
}
.right-\\[5px\\] {
  right: 5px;
}
.right-full {
  right: 100%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[35\\%\\] {
  top: 35%;
}
.top-\\[5px\\] {
  top: 5px;
}
.top-\\[65\\%\\] {
  top: 65%;
}
.top-\\[calc\\(100\\%\\+8px\\)\\] {
  top: calc(100% + 8px);
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[71\\] {
  z-index: 71;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-full {
  grid-column: 1 / -1;
}
.-m-1 {
  margin: -0.25rem;
}
.m-0 {
  margin: 0px;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-base {
  margin-left: 1rem;
  margin-right: 1rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-base {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.-mb-8 {
  margin-bottom: -2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-0 {
  margin-left: -0px;
}
.-ml-0\\.5 {
  margin-left: -0.125rem;
}
.-ml-px {
  margin-left: -1px;
}
.-mt-0 {
  margin-top: -0px;
}
.-mt-0\\.5 {
  margin-top: -0.125rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-large {
  margin-bottom: 1.5rem;
}
.mb-small {
  margin-bottom: 0.75rem;
}
.mb-xsmall {
  margin-bottom: 0.5rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[3\\.25rem\\] {
  margin-left: 3.25rem;
}
.ml-auto {
  margin-left: auto;
}
.ml-large {
  margin-left: 1.5rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2xsmall {
  margin-right: 0.25rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-large {
  margin-top: 1.5rem;
}
.mt-xlarge {
  margin-top: 2rem;
}
.mt-xsmall {
  margin-top: 0.5rem;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.flow-root {
  display: flow-root;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.size-12 {
  width: 3rem;
  height: 3rem;
}
.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.size-2\\.5 {
  width: 0.625rem;
  height: 0.625rem;
}
.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-7 {
  width: 1.75rem;
  height: 1.75rem;
}
.size-8 {
  width: 2rem;
  height: 2rem;
}
.size-9 {
  width: 2.25rem;
  height: 2.25rem;
}
.size-full {
  width: 100%;
  height: 100%;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-4\\/5 {
  height: 80%;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-60 {
  height: 15rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[min\\(26rem\\2c 55vh\\)\\] {
  height: min(26rem,55vh);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-large {
  height: 1.5rem;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-12 {
  max-height: 3rem;
}
.max-h-36 {
  max-height: 9rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-8 {
  max-height: 2rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[calc\\(100vh-1\\.5rem\\)\\] {
  max-height: calc(100vh - 1.5rem);
}
.max-h-\\[min\\(80vh\\2c 100\\%\\)\\] {
  max-height: min(80vh,100%);
}
.max-h-\\[var\\(--radix-popper-available-height\\)\\] {
  max-height: var(--radix-popper-available-height);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-5 {
  min-height: 1.25rem;
}
.min-h-\\[12rem\\] {
  min-height: 12rem;
}
.min-h-\\[70vh\\] {
  min-height: 70vh;
}
.min-h-\\[min\\(26rem\\2c 55vh\\)\\] {
  min-height: min(26rem,55vh);
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-fit {
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[1\\%\\] {
  width: 1%;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[8rem\\] {
  width: 8rem;
}
.w-\\[94\\%\\] {
  width: 94%;
}
.w-\\[calc\\(100\\%-1px\\)\\] {
  width: calc(100% - 1px);
}
.w-\\[calc\\(50\\%-32px\\)\\] {
  width: calc(50% - 32px);
}
.w-\\[calc\\(50\\%-8px\\)\\] {
  width: calc(50% - 8px);
}
.w-collapsedSidebar {
  width: 5rem;
}
.w-fit {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-large {
  width: 1.5rem;
}
.w-largeModal {
  width: 750px;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.w-sidebar {
  width: 250px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-36 {
  min-width: 9rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-52 {
  min-width: 13rem;
}
.min-w-60 {
  min-width: 15rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-80 {
  min-width: 20rem;
}
.min-w-\\[1\\.25rem\\] {
  min-width: 1.25rem;
}
.min-w-\\[11rem\\] {
  min-width: 11rem;
}
.min-w-\\[152px\\] {
  min-width: 152px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[94\\%\\] {
  min-width: 94%;
}
.min-w-full {
  min-width: 100%;
}
.min-w-modal {
  min-width: 520px;
}
.max-w-12 {
  max-width: 3rem;
}
.max-w-24 {
  max-width: 6rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-40 {
  max-width: 10rem;
}
.max-w-44 {
  max-width: 11rem;
}
.max-w-48 {
  max-width: 12rem;
}
.max-w-60 {
  max-width: 15rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-8 {
  max-width: 2rem;
}
.max-w-\\[12rem\\] {
  max-width: 12rem;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[352px\\] {
  max-width: 352px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[40rem\\] {
  max-width: 40rem;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[8rem\\] {
  max-width: 8rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-4\\/12 {
  flex-basis: 33.333333%;
}
.basis-8\\/12 {
  flex-basis: 66.666667%;
}
.basis-\\[6rem\\] {
  flex-basis: 6rem;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes dialoge-content {

  0% {
    transform: translate(-50%, -48%) scale(0.96);
    opacity: 0;
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
.animate-dialogue-content {
  animation: dialoge-content 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }

  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate-enter {
  animation: enter 150ms ease-out;
}
@keyframes leave {

  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(0.9);
    opacity: 0;
  }
}
.animate-leave {
  animation: leave 150ms ease-in forwards;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  -webkit-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-\\[3fr_1fr_40px\\] {
  grid-template-columns: 3fr 1fr 40px;
}
.grid-cols-\\[minmax\\(theme\\(spacing\\.24\\)\\2c auto\\)_1fr_minmax\\(theme\\(spacing\\.32\\)\\2c theme\\(spacing\\.40\\)\\)_theme\\(spacing\\.28\\)_theme\\(spacing\\.9\\)\\] {
  grid-template-columns: minmax(6rem,auto) 1fr minmax(8rem,10rem) 7rem 2.25rem;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-base {
  gap: 1rem;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-0\\.5 {
  column-gap: 0.125rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-14 {
  column-gap: 3.5rem;
}
.gap-x-16 {
  column-gap: 4rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-2xsmall {
  column-gap: 0.25rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-x-small {
  column-gap: 0.75rem;
}
.gap-x-xsmall {
  column-gap: 0.5rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2xsmall {
  row-gap: 0.25rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.gap-y-large {
  row-gap: 1.5rem;
}
.gap-y-small {
  row-gap: 0.75rem;
}
.gap-y-xsmall {
  row-gap: 0.5rem;
}
.-space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-blue-medium > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(48 79 233 / var(--tw-divide-opacity));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.divide-grey-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(238 239 242 / var(--tw-divide-opacity));
}
.divide-ui-border-base > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--border-base);
}
.divide-ui-border-subtle > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--border-subtle);
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-rounded {
  border-radius: 0.625rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-tl {
  border-top-left-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-blue-base {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.border-blue-light {
  --tw-border-opacity: 1;
  border-color: rgb(194 214 255 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-grey-30 {
  --tw-border-opacity: 1;
  border-color: rgb(205 208 213 / var(--tw-border-opacity));
}
.border-grey-40 {
  --tw-border-opacity: 1;
  border-color: rgb(134 140 152 / var(--tw-border-opacity));
}
.border-inherit {
  border-color: inherit;
}
.border-red-base {
  --tw-border-opacity: 1;
  border-color: rgb(223 28 65 / var(--tw-border-opacity));
}
.border-red-light {
  --tw-border-opacity: 1;
  border-color: rgb(248 201 210 / var(--tw-border-opacity));
}
.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-ui-border-base {
  border-color: var(--border-base);
}
.border-ui-border-strong {
  border-color: var(--border-strong);
}
.border-ui-border-subtle {
  border-color: var(--border-subtle);
}
.border-zinc-700 {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.border-t-blue-base {
  --tw-border-opacity: 1;
  border-top-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.border-t-grey-0 {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!bg-blue-dark {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 62 167 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-black\\/75 {
  background-color: rgb(0 0 0 / 0.75);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-base {
  --tw-bg-opacity: 1;
  background-color: rgb(55 93 251 / var(--tw-bg-opacity));
}
.bg-blue-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(37 62 167 / var(--tw-bg-opacity));
}
.bg-blue-light {
  --tw-bg-opacity: 1;
  background-color: rgb(194 214 255 / var(--tw-bg-opacity));
}
.bg-blue-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(235 241 255 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(239 250 246 / var(--tw-bg-opacity));
}
.bg-grey-0 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-grey-10 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.bg-grey-20 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 242 / var(--tw-bg-opacity));
}
.bg-grey-40 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 140 152 / var(--tw-bg-opacity));
}
.bg-grey-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 88 102 / var(--tw-bg-opacity));
}
.bg-grey-80 {
  --tw-bg-opacity: 1;
  background-color: rgb(18 24 34 / var(--tw-bg-opacity));
}
.bg-grey-90 {
  --tw-bg-opacity: 1;
  background-color: rgb(10 13 20 / var(--tw-bg-opacity));
}
.bg-inherit {
  background-color: inherit;
}
.bg-orange-base {
  --tw-bg-opacity: 1;
  background-color: rgb(241 123 44 / var(--tw-bg-opacity));
}
.bg-orange-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 235 / var(--tw-bg-opacity));
}
.bg-purple-base {
  --tw-bg-opacity: 1;
  background-color: rgb(110 63 243 / var(--tw-bg-opacity));
}
.bg-purple-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(238 235 255 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-base {
  --tw-bg-opacity: 1;
  background-color: rgb(223 28 65 / var(--tw-bg-opacity));
}
.bg-red-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(253 237 240 / var(--tw-bg-opacity));
}
.bg-teal-base {
  --tw-bg-opacity: 1;
  background-color: rgb(53 185 233 / var(--tw-bg-opacity));
}
.bg-teal-lighter {
  --tw-bg-opacity: 1;
  background-color: rgb(235 250 255 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-transparent\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-ui-bg-base {
  background-color: var(--bg-base);
}
.bg-ui-bg-base-hover {
  background-color: var(--bg-base-hover);
}
.bg-ui-bg-disabled {
  background-color: var(--bg-disabled);
}
.bg-ui-bg-overlay {
  background-color: var(--bg-overlay);
}
.bg-ui-border-base {
  background-color: var(--border-base);
}
.bg-ui-border-strong {
  background-color: var(--border-strong);
}
.bg-ui-fg-muted {
  background-color: var(--fg-muted);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600 {
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-green-500 {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-violet-500 {
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.fill-gray-500 {
  fill: #6b7280;
}
.fill-gray-800 {
  fill: #1f2937;
}
.fill-grey-50 {
  fill: #525866;
}
.fill-grey-90 {
  fill: #0A0D14;
}
.fill-purple-base {
  fill: #6E3FF3;
}
.fill-teal-base {
  fill: #35B9E9;
}
.stroke-gray-200 {
  stroke: #e5e7eb;
}
.stroke-grey-50 {
  stroke: #525866;
}
.stroke-purple-base {
  stroke: #6E3FF3;
}
.stroke-teal-base {
  stroke: #35B9E9;
}
.stroke-1 {
  stroke-width: 1;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-base {
  padding: 1rem;
}
.p-xsmall {
  padding: 0.5rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-base {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-large {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-small {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-base {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-large {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-small {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-xsmall {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-small {
  padding-left: 0.75rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[1px\\] {
  padding-right: 1px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-xlarge {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-end {
  text-align: end;
}
.font-jakarta {
  font-family: Plus Jakarta Sans, sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-menu-button {
  font-size: 13px;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-xxs {
  font-size: 0.625rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.\\!text-ui-fg-muted {
  color: var(--fg-muted) !important;
}
.text-\\[\\#0b5cad\\] {
  --tw-text-opacity: 1;
  color: rgb(11 92 173 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-blue-base {
  --tw-text-opacity: 1;
  color: rgb(55 93 251 / var(--tw-text-opacity));
}
.text-blue-dark {
  --tw-text-opacity: 1;
  color: rgb(37 62 167 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-green-base {
  --tw-text-opacity: 1;
  color: rgb(56 199 147 / var(--tw-text-opacity));
}
.text-green-dark {
  --tw-text-opacity: 1;
  color: rgb(45 159 117 / var(--tw-text-opacity));
}
.text-grey-0 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-grey-20 {
  --tw-text-opacity: 1;
  color: rgb(238 239 242 / var(--tw-text-opacity));
}
.text-grey-30 {
  --tw-text-opacity: 1;
  color: rgb(205 208 213 / var(--tw-text-opacity));
}
.text-grey-40 {
  --tw-text-opacity: 1;
  color: rgb(134 140 152 / var(--tw-text-opacity));
}
.text-grey-50 {
  --tw-text-opacity: 1;
  color: rgb(82 88 102 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-orange-base {
  --tw-text-opacity: 1;
  color: rgb(241 123 44 / var(--tw-text-opacity));
}
.text-orange-dark {
  --tw-text-opacity: 1;
  color: rgb(194 84 10 / var(--tw-text-opacity));
}
.text-purple-base {
  --tw-text-opacity: 1;
  color: rgb(110 63 243 / var(--tw-text-opacity));
}
.text-purple-dark {
  --tw-text-opacity: 1;
  color: rgb(90 54 191 / var(--tw-text-opacity));
}
.text-red-base {
  --tw-text-opacity: 1;
  color: rgb(223 28 65 / var(--tw-text-opacity));
}
.text-red-dark {
  --tw-text-opacity: 1;
  color: rgb(175 29 56 / var(--tw-text-opacity));
}
.text-teal-base {
  --tw-text-opacity: 1;
  color: rgb(53 185 233 / var(--tw-text-opacity));
}
.text-teal-dark {
  --tw-text-opacity: 1;
  color: rgb(31 135 173 / var(--tw-text-opacity));
}
.text-teal-lighter {
  --tw-text-opacity: 1;
  color: rgb(235 250 255 / var(--tw-text-opacity));
}
.text-ui-fg-base {
  color: var(--fg-base);
}
.text-ui-fg-faint {
  color: var(--fg-faint);
}
.text-ui-fg-muted {
  color: var(--fg-muted);
}
.text-ui-fg-smooth {
  color: var(--fg-smooth);
}
.text-ui-fg-subtle {
  color: var(--fg-subtle);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.text-zinc-100 {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.placeholder-ui-fg-muted::placeholder {
  color: var(--fg-muted);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-75 {
  opacity: 0.75;
}
.shadow-borders-with-shadow {
  --tw-shadow: 0px 1px 2px 0px rgba(82, 88, 102, 0.06);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-buttons-neutral {
  --tw-shadow: 0px 0px 14px -9px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(82, 88, 102, 0.06);
  --tw-shadow-colored: 0px 0px 14px -9px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-buttons-primary {
  --tw-shadow: 0px 4px 4px 0px rgba(255, 255, 255, 0.17) inset, 0px 1px 2px 0px rgba(37, 62, 167, 0.28);
  --tw-shadow-colored: inset 0px 4px 4px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-elevation-flyout {
  --tw-shadow: 0px 0px 0px 1px rgba(3, 7, 18, 0.08), 0px 8px 16px 0px rgba(3, 7, 18, 0.08);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 8px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-field-elevated {
  --tw-shadow: 0px 1px 2px 0px rgba(3, 7, 18, 0.12), 0px 0px 0px 1px rgba(3, 7, 18, 0.08);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color), 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.outline-transparent {
  outline-color: transparent;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[0\\.75px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0.75px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-green-dark\\/20 {
  --tw-ring-color: rgb(45 159 117 / 0.2);
}
.ring-grey-30 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(205 208 213 / var(--tw-ring-opacity));
}
.ring-grey-40 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 140 152 / var(--tw-ring-opacity));
}
.ring-grey-60\\/20 {
  --tw-ring-color: rgb(49 53 63 / 0.2);
}
.ring-red-dark\\/20 {
  --tw-ring-color: rgb(175 29 56 / 0.2);
}
.ring-slate-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(100 116 139 / var(--tw-ring-opacity));
}
.ring-teal-dark\\/20 {
  --tw-ring-color: rgb(31 135 173 / 0.2);
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-fg {
  transition-property: color, background-color, border-color, box-shadow, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[transform\\2c opacity\\] {
  will-change: transform,opacity;
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }

  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.ease-in {
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running {
  animation-play-state: running;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

/* Wrapper for radix's dropdown menu */
div[data-radix-popper-content-wrapper]:has(.dropdown-menu) {
  z-index: 60 !important;
}

/* Classes to remove number spinners from inputs of type number */
/* Chrome, Safari, Edge, Opera */
.remove-number-spinner::-webkit-outer-spin-button,
.remove-number-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.remove-number-spinner {
  -moz-appearance: textfield;
}

/* MapLibre dashboard shipment popup */
.dashboard-shipment-popup .maplibregl-popup-content {
  padding: 0;
}
.dashboard-shipment-popup .maplibregl-popup-close-button {
  font-size: 1rem;
  line-height: 1;
  width: 1.25rem;
  height: 1.25rem;
  top: 0.375rem;
  right: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  color: var(--fg-muted, #868c98);
}
.dashboard-shipment-popup .maplibregl-popup-close-button:hover {
  color: var(--fg-base, #0a0d14);
  background-color: var(--bg-field-hover, #f3f4f6);
}
.marker\\:text-ui-fg-muted *::marker {
  color: var(--fg-muted);
}
.marker\\:text-ui-fg-muted::marker {
  color: var(--fg-muted);
}
.placeholder\\:text-grey-40::placeholder {
  --tw-text-opacity: 1;
  color: rgb(134 140 152 / var(--tw-text-opacity));
}
.placeholder\\:text-ui-fg-muted::placeholder {
  color: var(--fg-muted);
}
.after\\:pointer-events-none::after {
  content: var(--tw-content);
  pointer-events: none;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:shadow-elevation-flyout::after {
  content: var(--tw-content);
  --tw-shadow: 0px 0px 0px 1px rgba(3, 7, 18, 0.08), 0px 8px 16px 0px rgba(3, 7, 18, 0.08);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 8px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.last\\:hidden:last-child {
  display: none;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.first-of-type\\:rounded-l-mid:first-of-type {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.last-of-type\\:-mr-1:last-of-type {
  margin-right: -0.25rem;
}
.last-of-type\\:rounded-r-mid:last-of-type {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.last-of-type\\:pr-4:last-of-type {
  padding-right: 1rem;
}
.invalid\\:\\!shadow-borders-error:invalid {
  --tw-shadow: 0px 0px 0px 1px rgba(223, 28, 65, 1), 0px 0px 0px 3px rgba(223, 28, 65, 0.15) !important;
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:shadow-borders-interactive-with-active:focus-within {
  --tw-shadow: 0px 0px 0px 1px rgba(45, 159, 117, 1), 0px 0px 0px 3px rgba(23, 177, 122, 0.10);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:cursor-grab:hover {
  cursor: grab;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:border-blue-dark:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 62 167 / var(--tw-border-opacity));
}
.hover\\:border-grey-30:hover {
  --tw-border-opacity: 1;
  border-color: rgb(205 208 213 / var(--tw-border-opacity));
}
.hover\\:border-grey-40:hover {
  --tw-border-opacity: 1;
  border-color: rgb(134 140 152 / var(--tw-border-opacity));
}
.hover\\:border-red-dark:hover {
  --tw-border-opacity: 1;
  border-color: rgb(175 29 56 / var(--tw-border-opacity));
}
.hover\\:border-transparent:hover {
  border-color: transparent;
}
.hover\\:border-ui-border-hover:hover {
  border-color: var(--border-hover);
}
.hover\\:border-ui-border-strong:hover {
  border-color: var(--border-strong);
}
.hover\\:border-ui-border-subtle:hover {
  border-color: var(--border-subtle);
}
.hover\\:bg-blue-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 62 167 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-medium:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(48 79 233 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-grey-0:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-grey-10:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.hover\\:bg-grey-20:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 242 / var(--tw-bg-opacity));
}
.hover\\:bg-red-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(175 29 56 / var(--tw-bg-opacity));
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-ui-bg-base-hover:hover {
  background-color: var(--bg-base-hover);
}
.hover\\:bg-ui-bg-disabled:hover {
  background-color: var(--bg-disabled);
}
.hover\\:bg-ui-bg-field-hover:hover {
  background-color: var(--bg-field-hover);
}
.hover\\:bg-zinc-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.hover\\:text-grey-50:hover {
  --tw-text-opacity: 1;
  color: rgb(82 88 102 / var(--tw-text-opacity));
}
.hover\\:text-red-base:hover {
  --tw-text-opacity: 1;
  color: rgb(223 28 65 / var(--tw-text-opacity));
}
.hover\\:text-ui-fg-base:hover {
  color: var(--fg-base);
}
.hover\\:text-ui-fg-muted:hover {
  color: var(--fg-muted);
}
.hover\\:text-ui-fg-subtle:hover {
  color: var(--fg-subtle);
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:shadow-elevation-flyout:hover {
  --tw-shadow: 0px 0px 0px 1px rgba(3, 7, 18, 0.08), 0px 8px 16px 0px rgba(3, 7, 18, 0.08);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 8px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:outline-blue-base:hover {
  outline-color: #375DFB;
}
.focus\\:z-\\[1\\]:focus {
  z-index: 1;
}
.focus\\:bg-ui-bg-base-hover:focus {
  background-color: var(--bg-base-hover);
}
.focus\\:shadow-borders-interactive-with-active:focus {
  --tw-shadow: 0px 0px 0px 1px rgba(45, 159, 117, 1), 0px 0px 0px 3px rgba(23, 177, 122, 0.10);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:border-none:focus-visible {
  border-style: none;
}
.focus-visible\\:bg-blue-dark:focus-visible {
  --tw-bg-opacity: 1;
  background-color: rgb(37 62 167 / var(--tw-bg-opacity));
}
.focus-visible\\:bg-ui-bg-base:focus-visible {
  background-color: var(--bg-base);
}
.focus-visible\\:bg-ui-bg-field-hover:focus-visible {
  background-color: var(--bg-field-hover);
}
.focus-visible\\:bg-zinc-700:focus-visible {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.focus-visible\\:underline:focus-visible {
  text-decoration-line: underline;
}
.focus-visible\\:shadow-borders-interactive-with-active:focus-visible {
  --tw-shadow: 0px 0px 0px 1px rgba(45, 159, 117, 1), 0px 0px 0px 3px rgba(23, 177, 122, 0.10);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:shadow-buttons-focus:focus-visible {
  --tw-shadow: 0px 0.75px 0px 0px rgba(255, 255, 255, 0.2) inset, 0px 1px 2px 0px rgba(3, 7, 18, 0.4), 0px 0px 0px 1px rgba(3, 7, 18, 0.8), 0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(59, 130, 246, 0.6);
  --tw-shadow-colored: inset 0px 0.75px 0px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color), 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 2px var(--tw-shadow-color), 0px 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:shadow-none:focus-visible {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ui-border-strong:focus-visible {
  --tw-ring-color: var(--border-strong);
}
.focus-visible\\:hover\\:bg-zinc-800:hover:focus-visible {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.active\\:bg-blue-darker:active {
  --tw-bg-opacity: 1;
  background-color: rgb(22 38 100 / var(--tw-bg-opacity));
}
.active\\:bg-grey-0:active {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.active\\:bg-grey-10:active {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.active\\:bg-grey-20:active {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 242 / var(--tw-bg-opacity));
}
.active\\:bg-red-darker:active {
  --tw-bg-opacity: 1;
  background-color: rgb(113 14 33 / var(--tw-bg-opacity));
}
.active\\:bg-transparent:active {
  background-color: transparent;
}
.active\\:bg-zinc-700:active {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.active\\:shadow-buttons-neutral-pressed:active {
  --tw-shadow: 0px 1px 4px 0px rgba(3, 7, 18, 0.12);
  --tw-shadow-colored: 0px 1px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-none:active {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:active\\:bg-zinc-700:active:focus-visible {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:border-transparent:disabled {
  border-color: transparent;
}
.disabled\\:border-ui-border-subtle:disabled {
  border-color: var(--border-subtle);
}
.disabled\\:bg-blue-base:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(55 93 251 / var(--tw-bg-opacity));
}
.disabled\\:bg-transparent:disabled {
  background-color: transparent;
}
.disabled\\:bg-ui-bg-disabled:disabled {
  background-color: var(--bg-disabled);
}
.disabled\\:text-blue-light:disabled {
  --tw-text-opacity: 1;
  color: rgb(194 214 255 / var(--tw-text-opacity));
}
.disabled\\:text-ui-fg-muted:disabled {
  color: var(--fg-muted);
}
.disabled\\:placeholder-ui-fg-muted:disabled::placeholder {
  color: var(--fg-muted);
}
.disabled\\:opacity-80:disabled {
  opacity: 0.8;
}
.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group\\/time-input:invalid .group-invalid\\/time-input\\:\\!shadow-borders-error {
  --tw-shadow: 0px 0px 0px 1px rgba(223, 28, 65, 1), 0px 0px 0px 3px rgba(223, 28, 65, 0.15) !important;
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.group:hover .group-hover\\:border-grey-30 {
  --tw-border-opacity: 1;
  border-color: rgb(205 208 213 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:bg-ui-bg-base-hover {
  background-color: var(--bg-base-hover);
}
.group:hover .group-hover\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-ui-fg-smooth {
  color: var(--fg-smooth);
}
.group\\/action:hover .group-hover\\/action\\:opacity-100 {
  opacity: 1;
}
.group\\/row:hover .group-hover\\/row\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:focus-visible .group-focus-visible\\:\\!shadow-buttons-focus {
  --tw-shadow: 0px 0.75px 0px 0px rgba(255, 255, 255, 0.2) inset, 0px 1px 2px 0px rgba(3, 7, 18, 0.4), 0px 0px 0px 1px rgba(3, 7, 18, 0.8), 0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(59, 130, 246, 0.6) !important;
  --tw-shadow-colored: inset 0px 0.75px 0px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color), 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 2px var(--tw-shadow-color), 0px 0px 0px 4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.group:focus-visible .group-focus-visible\\:shadow-buttons-focus {
  --tw-shadow: 0px 0.75px 0px 0px rgba(255, 255, 255, 0.2) inset, 0px 1px 2px 0px rgba(3, 7, 18, 0.4), 0px 0px 0px 1px rgba(3, 7, 18, 0.8), 0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(59, 130, 246, 0.6);
  --tw-shadow-colored: inset 0px 0.75px 0px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color), 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 2px var(--tw-shadow-color), 0px 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:disabled .group-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.group:disabled .group-disabled\\:border {
  border-width: 1px;
}
.group:disabled .group-disabled\\:\\!border-grey-10 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(246 248 250 / var(--tw-border-opacity)) !important;
}
.group:disabled .group-disabled\\:\\!border-ui-border-strong {
  border-color: var(--border-strong) !important;
}
.group:disabled .group-disabled\\:border-ui-border-strong {
  border-color: var(--border-strong);
}
.group:disabled .group-disabled\\:\\!bg-ui-bg-disabled {
  background-color: var(--bg-disabled) !important;
}
.group:disabled .group-disabled\\:\\!text-ui-fg-faint {
  color: var(--fg-faint) !important;
}
.group:disabled .group-disabled\\:text-ui-fg-faint {
  color: var(--fg-faint);
}
.group:disabled .group-disabled\\:text-ui-fg-muted {
  color: var(--fg-muted);
}
.group:disabled .group-disabled\\:shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:not([data-selected]) .group-\\[\\:not\\(\\[data-selected\\]\\)\\]\\:hidden {
  display: none;
}
.group.is-active .group-\\[\\.is-active\\]\\:text-blue-base {
  --tw-text-opacity: 1;
  color: rgb(55 93 251 / var(--tw-text-opacity));
}
.group.is-active .group-\\[\\.is-active\\]\\:text-ui-fg-base {
  color: var(--fg-base);
}
.group:not(:disabled):hover .group-\\[\\:not\\(\\:disabled\\)\\]\\:group-hover\\:border-grey-90 {
  --tw-border-opacity: 1;
  border-color: rgb(10 13 20 / var(--tw-border-opacity));
}
.group:not(:disabled):hover .group-\\[\\:not\\(\\:disabled\\)\\]\\:group-hover\\:text-ui-fg-base {
  color: var(--fg-base);
}
.has-\\[\\*\\[data-state\\=open\\]\\]\\:bg-ui-bg-base-hover:has(*[data-state=open]) {
  background-color: var(--bg-base-hover);
}
.has-\\[\\:focus\\]\\:shadow-borders-interactive-with-active:has(:focus) {
  --tw-shadow: 0px 0px 0px 1px rgba(45, 159, 117, 1), 0px 0px 0px 3px rgba(23, 177, 122, 0.10);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.aria-selected\\:\\!bg-ui-bg-highlight[aria-selected="true"] {
  background-color: var(--bg-highlight) !important;
}
.aria-selected\\:\\!text-blue-base[aria-selected="true"] {
  --tw-text-opacity: 1 !important;
  color: rgb(55 93 251 / var(--tw-text-opacity)) !important;
}
.aria-selected\\:text-grey-0[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.aria-\\[invalid\\=true\\]\\:\\!shadow-borders-error[aria-invalid=true] {
  --tw-shadow: 0px 0px 0px 1px rgba(223, 28, 65, 1), 0px 0px 0px 3px rgba(223, 28, 65, 0.15) !important;
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.group\\/time-input[aria-invalid=true] .group-aria-\\[invalid\\=true\\]\\/time-input\\:\\!shadow-borders-error {
  --tw-shadow: 0px 0px 0px 1px rgba(223, 28, 65, 1), 0px 0px 0px 3px rgba(223, 28, 65, 0.15) !important;
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.group[aria-invalid=true] .group-aria-\\[invalid\\=true\\]\\:shadow-borders-error {
  --tw-shadow: 0px 0px 0px 1px rgba(223, 28, 65, 1), 0px 0px 0px 3px rgba(223, 28, 65, 0.15);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[state\\=active\\]\\:border-blue-base[data-state=active] {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.data-\\[state\\=checked\\]\\:border-blue-base[data-state=checked] {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.data-\\[state\\=checked\\]\\:bg-blue-lighter[data-state=checked] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 241 255 / var(--tw-bg-opacity));
}
.data-\\[state\\=open\\]\\:bg-blue-medium[data-state=open] {
  --tw-bg-opacity: 1;
  background-color: rgb(48 79 233 / var(--tw-bg-opacity));
}
.data-\\[state\\=open\\]\\:bg-grey-10[data-state=open] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.data-\\[disabled\\]\\:text-ui-fg-faint[data-disabled] {
  color: var(--fg-faint);
}
.data-\\[state\\=active\\]\\:text-blue-base[data-state=active] {
  --tw-text-opacity: 1;
  color: rgb(55 93 251 / var(--tw-text-opacity));
}
.data-\\[state\\=checked\\]\\:text-blue-base[data-state=checked] {
  --tw-text-opacity: 1;
  color: rgb(55 93 251 / var(--tw-text-opacity));
}
.data-\\[state\\=active\\]\\:shadow-none[data-state=active] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=closed\\]\\:shadow-none[data-state=closed] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=open\\]\\:shadow-borders-interactive-with-active[data-state=open] {
  --tw-shadow: 0px 0px 0px 1px rgba(45, 159, 117, 1), 0px 0px 0px 3px rgba(23, 177, 122, 0.10);
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=delayed-open\\]\\:animate-in[data-state=delayed-open] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=instant-open\\]\\:animate-in[data-state=instant-open] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state=open] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state=closed] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:fade-out[data-state=closed] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=delayed-open\\]\\:fade-in-0[data-state=delayed-open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=instant-open\\]\\:fade-in-0[data-state=instant-open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in[data-state=open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state=open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-90[data-state=closed] {
  --tw-exit-scale: .9;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=delayed-open\\]\\:zoom-in-95[data-state=delayed-open] {
  --tw-enter-scale: .95;
}
.data-\\[state\\=instant-open\\]\\:zoom-in-95[data-state=instant-open] {
  --tw-enter-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state=open] {
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open] {
  --tw-enter-scale: .95;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-in-from-bottom-2[data-state=closed] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom-0[data-state=open] {
  --tw-enter-translate-y: 0px;
}
.group[data-state=checked] .group-data-\\[state\\=checked\\]\\:border-none {
  border-style: none;
}
.group[data-active] .group-data-\\[active\\]\\:border-blue-base {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.group[data-state=checked] .group-data-\\[state\\=checked\\]\\:border-blue-base {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.group[data-state=indeterminate] .group-data-\\[state\\=indeterminate\\]\\:border-blue-base {
  --tw-border-opacity: 1;
  border-color: rgb(55 93 251 / var(--tw-border-opacity));
}
.group[data-state=active] .group-data-\\[state\\=active\\]\\:bg-blue-base {
  --tw-bg-opacity: 1;
  background-color: rgb(55 93 251 / var(--tw-bg-opacity));
}
.group[data-state=checked] .group-data-\\[state\\=checked\\]\\:bg-blue-base {
  --tw-bg-opacity: 1;
  background-color: rgb(55 93 251 / var(--tw-bg-opacity));
}
.group[data-state=indeterminate] .group-data-\\[state\\=indeterminate\\]\\:bg-blue-base {
  --tw-bg-opacity: 1;
  background-color: rgb(55 93 251 / var(--tw-bg-opacity));
}
.group[data-selected] .group-data-\\[selected\\]\\:font-semibold {
  font-weight: 600;
}
.group[data-active] .group-data-\\[active\\]\\:text-blue-base {
  --tw-text-opacity: 1;
  color: rgb(55 93 251 / var(--tw-text-opacity));
}
.group[data-state=active] .group-data-\\[state\\=active\\]\\:text-grey-0 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
:is(.dark .dark\\:border-gray-800) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
:is(.dark .dark\\:bg-gray-950) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:fill-gray-200) {
  fill: #e5e7eb;
}
:is(.dark .dark\\:fill-gray-500) {
  fill: #6b7280;
}
:is(.dark .dark\\:stroke-gray-800) {
  stroke: #1f2937;
}
:is(.dark .dark\\:text-gray-300) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-50) {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-600) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:bg-gray-800:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:text-gray-50:hover) {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
:is(.dark .group:hover .dark\\:group-hover\\:text-gray-50) {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
@media (min-width: 640px) {

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:w-28 {
    width: 7rem;
  }

  .sm\\:w-\\[280px\\] {
    width: 280px;
  }

  .sm\\:w-\\[300px\\] {
    width: 300px;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mx-xlarge {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {

  .lg\\:mx-4xlarge {
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .lg\\:max-h-\\[min\\(26rem\\2c 55vh\\)\\] {
    max-height: min(26rem,55vh);
  }

  .lg\\:w-\\[min\\(100\\%\\2c 22rem\\)\\] {
    width: min(100%,22rem);
  }

  .lg\\:flex-\\[2\\] {
    flex: 2;
  }

  .lg\\:shrink-0 {
    flex-shrink: 0;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }
}
@media (min-width: 1280px) {

  .xl\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .xl\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:max-w-7xl {
    max-width: 80rem;
  }

  .xl\\:max-w-full {
    max-width: 100%;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1fr_2fr\\] {
    grid-template-columns: 1fr 2fr;
  }

  .xl\\:px-small {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
@media print {

  .print\\:hidden {
    display: none;
  }

  .print\\:border-none {
    border-style: none;
  }

  .print\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
.\\[\\&\\:\\:--webkit-search-cancel-button\\]\\:hidden::--webkit-search-cancel-button {
  display: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:hidden::-webkit-search-cancel-button {
  display: none;
}
.\\[\\&\\:\\:-webkit-search-decoration\\]\\:hidden::-webkit-search-decoration {
  display: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-4::-webkit-slider-thumb {
  height: 1rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-4::-webkit-slider-thumb {
  width: 1rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:cursor-pointer::-webkit-slider-thumb {
  cursor: pointer;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-ui-fg-base::-webkit-slider-thumb {
  background-color: var(--fg-base);
}
.\\[\\&_div\\]\\:bg-blue-dark div {
  --tw-bg-opacity: 1;
  background-color: rgb(37 62 167 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-green-dark div {
  --tw-bg-opacity: 1;
  background-color: rgb(45 159 117 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-grey-40 div {
  --tw-bg-opacity: 1;
  background-color: rgb(134 140 152 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-orange-base div {
  --tw-bg-opacity: 1;
  background-color: rgb(241 123 44 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-orange-dark div {
  --tw-bg-opacity: 1;
  background-color: rgb(194 84 10 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-purple-base div {
  --tw-bg-opacity: 1;
  background-color: rgb(110 63 243 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-red-base div {
  --tw-bg-opacity: 1;
  background-color: rgb(223 28 65 / var(--tw-bg-opacity));
}
.\\[\\&_div\\]\\:bg-teal-dark div {
  --tw-bg-opacity: 1;
  background-color: rgb(31 135 173 / var(--tw-bg-opacity));
}
.\\[\\&_svg\\]\\:text-ui-fg-muted svg {
  color: var(--fg-muted);
}
.\\[\\&_svg\\]\\:opacity-0 svg {
  opacity: 0;
}
.\\[\\&_td\\:first-child\\]\\:pl-6 td:first-child {
  padding-left: 1.5rem;
}
.\\[\\&_td\\:last-child\\]\\:pr-6 td:last-child {
  padding-right: 1.5rem;
}
.\\[\\&_th\\:first-child\\]\\:rounded-l-md th:first-child {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.\\[\\&_th\\:first-child\\]\\:pl-6 th:first-child {
  padding-left: 1.5rem;
}
.\\[\\&_th\\:first-of-type\\]\\:w-1\\/2 th:first-of-type {
  width: 50%;
}
.\\[\\&_th\\:last-child\\]\\:rounded-r-md th:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.\\[\\&_th\\:last-child\\]\\:pr-6 th:last-child {
  padding-right: 1.5rem;
}
.\\[\\&_th\\:last-of-type\\]\\:w-\\[1\\%\\] th:last-of-type {
  width: 1%;
}
.\\[\\&_th\\]\\:w-1\\/6 th {
  width: 16.666667%;
}
.\\[\\&_tr\\:hover\\]\\:bg-grey-10 tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.\\[\\&_tr\\]\\:bg-grey-0 tr {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\[\\&_tr\\]\\:bg-grey-10 tr {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.\\[\\&_tr\\]\\:hover\\:bg-grey-0:hover tr {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
`, "",{"version":3,"sources":["webpack://./app/main.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,qNAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,iCAAc;IAAd,uCAAc;IAAd,qCAAc;IAAd,wCAAc;IAAd,wCAAc;IAAd,iCAAc;IAAd,qCAAc;IAAd,uCAAc;IAAd,uCAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,iCAAc;IAAd,kCAAc;IAAd,kCAAc;IAAd,gCAAc;EAAA;;EAAd;EAAA;AAAc;;EAAd;IAAA,kCAAc;IAAd,mCAAc;IAAd,kCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAmChB;EAAA,qNAAkD;EAAlD,mBAAkD;EAAlD,oBAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;AAIlD;EAAA,qNAAkD;EAAlD,kBAAkD;EAAlD,iBAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;AAIlD;EAAA,qNAAkD;EAAlD,mBAAkD;EAAlD,oBAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;AAIlD;EAAA,qNAAkD;EAAlD,kBAAkD;EAAlD,iBAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;AAIlD;EAAA,qNAAgD;EAAhD,kBAAgD;EAAhD,iBAAgD;EAAhD,gBAAgD;EAAhD;AAAgD;AAIhD;EAAA,qNAAmD;EAAnD,kBAAmD;EAAnD,iBAAmD;EAAnD,gBAAmD;EAAnD;AAAmD;AAInD;EAAA,qNAAmD;EAAnD,kBAAmD;EAAnD,iBAAmD;EAAnD,gBAAmD;EAAnD;AAAmD;AAInD;EAAA,qNAAoD;EAApD,eAAoD;EAApD,mBAAoD;EAApD,gBAAoD;EAApD;AAAoD;AAIpD;EAAA,qNAAmD;EAAnD,eAAmD;EAAnD,mBAAmD;EAAnD,gBAAmD;EAAnD;AAAmD;AAInD;EAAA,qNAAmD;EAAnD,eAAmD;EAAnD,mBAAmD;EAAnD,gBAAmD;EAAnD;AAAmD;AAInD;EAAA,qNAAkD;EAAlD,mBAAkD;EAAlD,oBAAkD;EAAlD,gBAAkD;EAAlD;AAAkD;AAIlD;EAAA,qNAAoD;EAApD,mBAAoD;EAApD,oBAAoD;EAApD,gBAAoD;EAApD;AAAoD;AAIpD;EAAA,qNAAmD;EAAnD,mBAAmD;EAAnD,gBAAmD;EAAnD;AAAmD;AAlFvD;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,4CAAmB;IAAnB;EAAmB;;EAAnB;IAAA,yCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;;EAAnB;IAAA,qBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,qBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,4GAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;;EAAnB;IAAA,qBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAsFnB,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;AA9HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,0BA+HA;EA/HA;AA+HA;AA/HA;EAAA,0BA+HA;EA/HA;AA+HA;AA/HA;EAAA,0BA+HA;EA/HA;AA+HA;AA/HA;EAAA,0BA+HA;EA/HA;AA+HA;AA/HA;EAAA,0BA+HA;EA/HA,wFA+HA;EA/HA,oGA+HA;EA/HA;AA+HA;AA/HA;EAAA,gBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,+BA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,gCA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,qGA+HA;EA/HA,8GA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,4FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,wFA+HA;EA/HA,oGA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,4FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,4FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA,yNA+HA;EA/HA,oOA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,2GA+HA;EA/HA,yGA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,iDA+HA;EA/HA,2DA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,qGA+HA;EA/HA,8GA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oOA+HA;EA/HA,+OA+HA;EA/HA;AA+HA;AA/HA;EAAA,yNA+HA;EA/HA,oOA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,iCA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,4FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,+BA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,qGA+HA;EA/HA,8GA+HA;EA/HA;AA+HA;AA/HA;EAAA,qGA+HA;EA/HA,8GA+HA;EA/HA;AA+HA;AA/HA;EAAA,0FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA,4FA+HA;EA/HA,mGA+HA;EA/HA;AA+HA;AA/HA;EAAA,qBA+HA;EA/HA,yBA+HA;EA/HA,2BA+HA;EA/HA,yBA+HA;EA/HA,0BA+HA;EA/HA,+BA+HA;EA/HA;AA+HA;AA/HA;EAAA,qBA+HA;EA/HA,yBA+HA;EA/HA,2BA+HA;EA/HA,yBA+HA;EA/HA,0BA+HA;EA/HA,+BA+HA;EA/HA;AA+HA;AA/HA;EAAA,qBA+HA;EA/HA,yBA+HA;EA/HA,2BA+HA;EA/HA,yBA+HA;EA/HA,0BA+HA;EA/HA,+BA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA,yBA+HA;EA/HA,0BA+HA;EA/HA,wBA+HA;EA/HA,yBA+HA;EA/HA,8BA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,sBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;EAAA,oBA+HA;EA/HA;AA+HA;AA/HA;;EAAA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA,iBA+HA;IA/HA;EA+HA;AAAA;AA/HA;;EAAA;IAAA;EA+HA;;EA/HA;IAAA,iBA+HA;IA/HA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;AAAA;AA/HA;;EAAA;IAAA,mBA+HA;IA/HA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;AAAA;AA/HA;;EAAA;IAAA,iBA+HA;IA/HA;EA+HA;;EA/HA;IAAA,iBA+HA;IA/HA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA,qBA+HA;IA/HA;EA+HA;AAAA;AA/HA;;EAAA;IAAA;EA+HA;;EA/HA;IAAA;EA+HA;;EA/HA;IAAA,sBA+HA;IA/HA,8BA+HA;IA/HA;EA+HA;AAAA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,wBA+HA;UA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,gCA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,iCA+HA;EA/HA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA;AA/HA;EAAA,kBA+HA;EA/HA;AA+HA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    --bg-base: rgba(255, 255, 255, 1);\n    --bg-base-hover: rgba(248, 250, 251, 1);\n    --bg-disabled: rgba(246, 248, 250, 1);\n    --bg-field-hover: rgba(243, 244, 246, 1);\n    --bg-highlight: rgba(235, 241, 255, 0.7);\n    --bg-overlay: rgba(3, 7, 18, 0.4);\n    --border-base: rgba(239, 240, 246, 1);\n    --border-subtle: rgba(243, 244, 246, 1);\n    --border-strong: rgba(226, 228, 233, 1);\n    --border-hover: rgba(215, 218, 225, 1);\n    --fg-base: rgba(10, 13, 20, 1);\n    --fg-subtle: rgba(82, 88, 102, 1);\n    --fg-muted: rgba(134, 140, 152, 1);\n    --fg-faint: rgba(205, 208, 213, 1);\n    --fg-smooth: rgba(32, 35, 45, 1);\n  }\n\n  html {\n    @apply overflow-hidden;\n  }\n\n  body {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n  }\n}\n\n@layer components {\n  .txt-base-regular {\n    @apply text-sm font-normal leading-normal font-sans\n  }\n\n  .txt-small-regular {\n    @apply text-xs font-normal leading-normal font-sans\n  }\n\n  .txt-base-regular-plus {\n    @apply text-sm font-medium leading-normal font-sans\n  }\n\n  .txt-small-regular-plus {\n    @apply text-xs font-medium leading-normal font-sans\n  }\n\n  .txt-small-regular-semibold {\n    @apply text-xs font-bold leading-normal font-sans\n  }\n\n  .txt-compact-small {\n    @apply text-xs font-normal leading-relaxed font-sans\n  }\n\n  .txt-compact-small-plus {\n    @apply text-xs font-medium leading-relaxed font-sans\n  }\n\n  .txt-medium-regular {\n    @apply text-base font-normal leading-normal font-sans\n  }\n\n  .txt-compact-medium {\n    @apply text-base font-normal leading-tight font-sans\n  }\n\n  .txt-compact-medium-plus {\n    @apply text-base font-medium leading-tight font-sans\n  }\n\n  .txt-large-semibold {\n    @apply text-lg font-medium leading-normal font-sans\n  }\n\n  .txt-large-bold {\n    @apply text-lg font-semibold leading-normal font-sans\n  }\n\n  .txt-xlarge-semibold {\n    @apply text-xxl font-medium leading-normal font-sans\n  }\n}\n\n/* Wrapper for radix's dropdown menu */\ndiv[data-radix-popper-content-wrapper]:has(.dropdown-menu) {\n  z-index: 60 !important;\n}\n\n/* Classes to remove number spinners from inputs of type number */\n/* Chrome, Safari, Edge, Opera */\n.remove-number-spinner::-webkit-outer-spin-button,\n.remove-number-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.remove-number-spinner {\n  -moz-appearance: textfield;\n}\n\n/* MapLibre dashboard shipment popup */\n.dashboard-shipment-popup .maplibregl-popup-content {\n  padding: 0;\n}\n.dashboard-shipment-popup .maplibregl-popup-close-button {\n  font-size: 1rem;\n  line-height: 1;\n  width: 1.25rem;\n  height: 1.25rem;\n  top: 0.375rem;\n  right: 0.375rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.25rem;\n  color: var(--fg-muted, #868c98);\n}\n.dashboard-shipment-popup .maplibregl-popup-close-button:hover {\n  color: var(--fg-base, #0a0d14);\n  background-color: var(--bg-field-hover, #f3f4f6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
